import { RichText } from './types'

export function hasRichText(richtext?: RichText | string) {
  if (!richtext || richtext === '') {
    return false
  }

  return true
}
